import * as types from '../constants';

export const initBookingListState = () => ({
  type: types.INIT_BOOKING_LIST_STATE,
});

export const setViewType = viewType => ({
  type: types.SET_VIEW_TYPE,
  payload: viewType
});

export const setBookingList = bookingList => ({
  type: types.SET_BOOKING_LIST,
  payload: bookingList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_BOOKING_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_BOOKING_PAGINATION_ITEM,
  payload: paginationItem
});

export const setSortItem = sortItem => ({
  type: types.SET_BOOKING_SORT_ITEM,
  payload: sortItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_BOOKING_FILTER_ITEM,
  payload: filterItem
});